// approvalFlowViewModel.ts
import { useEffect, useReducer } from "react";
import {
  approvalFlowReducer,
  approvalFlowInitialState,
  ApprovalFlowState,
} from "./approvalFlow.reducer";
import {
  createApprovalFlowApi,
  deleteApprovals,
  detailsApproval,
  getApprovals,
  updateApprovals,
  updateApprovalLevel,
} from "../api/ApprovalFlow.api";
import {
  setApprovals,
  setDetailedApprovals,
  setDialogMode,
  setToast,
} from "./approvalFlow.action";
import { setListLoading } from "./approvalFlow.action";
export const useApprovalFlowViewModel = (
  initial?: Partial<ApprovalFlowState>,
  options?: { autoFetch?: boolean },
) => {
  const autoFetch = options?.autoFetch ?? true;
  const [state, dispatch] = useReducer(approvalFlowReducer, {
    ...approvalFlowInitialState,
    ...initial,
  });

  const showToastMessage = (
    message: string,
    type: "success" | "error" | "warning" | "info",
  ) => dispatch(setToast({ isVisible: true, message, type }));
  useEffect(() => {
    if (autoFetch) {
      fetchApprovals();
    }
  }, []);
  const fetchApprovals = async (params: any = {}) => {
    try {
      dispatch(setListLoading(true));
      const resp = await getApprovals();
      dispatch(setApprovals(resp.data));
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setListLoading(false));
    }
  };
  const deleteApprovalsData = async () => {
    const id = state.deletingFlowId;
    if (!id) return;
    try {
      dispatch(setListLoading(true));
      const resp = await deleteApprovals(id);
      console.log(resp);
      showToastMessage("Approval deleted successfully", "success");
      dispatch({ type: "CLOSE_DELETE_DIALOG" });
      await fetchApprovals();
    } catch (error) {
      console.log(error);
      showToastMessage(
        "Cannot delete flow: it has pending job approvals. Complete or cancel them first.",
        "error",
      );
      dispatch({ type: "CLOSE_DELETE_DIALOG" });
    } finally {
      dispatch(setListLoading(false));
    }
  };
  const updateApprovalsData = async (id: any, payload: any) => {
    try {
      const resp = await updateApprovals(id, payload);
      console.log(resp);
      showToastMessage("Approval update successfully", "success");
      await fetchApprovals();

      dispatch({ type: "CLOSE_DELETE_DIALOG" });
    } catch (error) {
      console.log(error);
      showToastMessage("Failed to update approval", "error");
    }
  };
  const fetchDetailedApprovals = async (
    flowId: string,
    mode: "edit" | "view",
  ) => {
    try {
      //  dispatch(setLoading(true));

      const resp = await detailsApproval(flowId);

      dispatch(setDetailedApprovals(resp.data));
      dispatch(setDialogMode(mode));
      dispatch({ type: "SET_FLOW_DIALOG_OPEN", payload: true });
    } catch (err) {
      console.error("Failed to fetch approval flow details", err);
    } finally {
      // dispatch(setLoading(false));
    }
  };

  const createApprovalFlow = async (payload: any) => {
    try {
      const resp = await createApprovalFlowApi(payload);
      await fetchApprovals();
      return resp;
    } catch (err) {
      console.error("Error creating approval flow", err);
      showToastMessage("Failed to create approval flow", "error");
      throw err;
    }
  };

  const updateApprovalLevelData = async (
    flowId: string,
    levelId: string,
    payload: any,
  ) => {
    return await updateApprovalLevel(flowId, levelId, payload);
  };

  return {
    state,
    dispatch,
    fetchApprovals,
    deleteApprovalsData,
    updateApprovalsData,
    fetchDetailedApprovals,
    createApprovalFlow,
    updateApprovalLevelData,
   
  };
};
